import { Component } from '@theme/component';

/**
 * @typedef {Object} CustomProductRecsRefs
 */

/** @extends {Component<CustomProductRecsRefs>} */
class CustomProductRecs extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#trackCurrentProduct();
  }

  activateTab(tabName, event) {
    this.querySelectorAll('.custom-product-recs__tab').forEach((tab) => {
      const isActive = tab.dataset.tabTarget === tabName;
      tab.classList.toggle('custom-product-recs__tab--active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
    });

    this.querySelectorAll('.custom-product-recs__panel').forEach((panel) => {
      panel.classList.toggle('custom-product-recs__panel--hidden', panel.dataset.panel !== tabName);
    });

    if (tabName === 'recently-viewed') {
      this.#renderRecentlyViewed();
    }
  }

  #trackCurrentProduct() {
    const scriptEl = this.querySelector('[data-current-product]');
    if (!scriptEl) return;
    try {
      const product = JSON.parse(scriptEl.textContent);
      this.#addToRecentlyViewed(product);
    } catch {}
  }

  #addToRecentlyViewed(product) {
    try {
      const stored = JSON.parse(localStorage.getItem('sf_recently_viewed') || '[]');
      const filtered = stored.filter((p) => p.id !== product.id);
      filtered.unshift(product);
      localStorage.setItem('sf_recently_viewed', JSON.stringify(filtered.slice(0, 10)));
    } catch {}
  }

  #renderRecentlyViewed() {
    const list = this.querySelector('[data-recently-viewed-list]');
    if (!list || list.children.length > 0) return;

    try {
      const stored = JSON.parse(localStorage.getItem('sf_recently_viewed') || '[]');
      const currentId = this.dataset.currentProductId ? Number(this.dataset.currentProductId) : null;
      const products = stored.filter((p) => p.id !== currentId).slice(0, 4);

      if (products.length === 0) {
        list.innerHTML = `<p class="custom-product-recs__rv-empty">${window.Shopify?.theme?.name ? '' : 'No recently viewed products.'}</p>`;
        return;
      }

      list.innerHTML = products
        .map(
          (p) => `
        <div class="custom-product-recs__rv-card">
          <button
            title="Add to wishlist"
            aria-label="Add product to wishlist"
            class="st-wishlist-button"
            type="button"
            data-type="product-card"
            data-handle="${p.handle ?? ''}"
          ></button>
          <a href="${p.url}" class="custom-product-recs__rv-link">
            <div class="custom-product-recs__rv-image">
              <img
                src="${p.image}"
                alt="${p.title}"
                width="315"
                height="315"
                loading="lazy"
              >
            </div>
            <div class="custom-product-recs__rv-info">
              <p class="custom-product-recs__rv-title">${p.title}</p>
              <p class="custom-product-recs__rv-price">${p.price}</p>
            </div>
          </a>
        </div>
      `
        )
        .join('');
    } catch {}
  }
}

if (!customElements.get('custom-product-recs')) {
  customElements.define('custom-product-recs', CustomProductRecs);
}
